import React, { useEffect, useRef, useState } from "react";
import Textfield from "../Textfield";
import styled from "styled-components";
import {
  Scan,
  Scan1,
  ScanCrackers,
  ScanEveningBg,
  ScanInfo,
} from "../../assets/images";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Colors } from "../../ColorConstants";

const ScanSignUpForm = ({
  onTryLuck,
  isValid,
  onVerify,
  formData,
  onChange,
  onTCClick,
}) => {
  const [showInfo, setInfo] = useState(false);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setInfo(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  return (
    <MainFormContainer>
      <FormContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
          }}
        >
          <BannerImage src={Scan} />
          <InfoText ref={wrapperRef}>
            {showInfo && (
              <div>
                {
                  "Scan the code > Fill the form > Get verified > Spin the wheel > Win Offers"
                }
              </div>
            )}
            Enter your details to Spin
            <img src={ScanInfo} onClick={() => setInfo(!showInfo)} />
          </InfoText>
          <OTPForm>
            {isValid !== "undefined" ? (
              <>
                <PhoneInputWrapper>
                  <StyledPhoneInput
                    enableSearch={true}
                    value={formData.countryCode}
                    onChange={(phone) =>
                      onChange({
                        target: { value: phone, name: "countryCode" },
                      })
                    }
                    disabled={isValid === "valid"}
                  />
                  <input
                    placeholder="Your phone number (Without Country Code)"
                    //   isRounded
                    value={formData.phone}
                    name="phone"
                    onChange={onChange}
                    style={{ border: "none", outline: "none" }}
                    disabled={isValid !== "undefined"}
                    pattern="[0-9]*"
                    inputmode="numeric"
                  />
                </PhoneInputWrapper>
                <Textfield
                  size="100%"
                  placeholder="Your Email ID"
                  isRounded
                  value={formData.email}
                  name="email"
                  onChange={onChange}
                  disabled={isValid === "valid" && formData.email}
                />
                <Textfield
                  size="100%"
                  placeholder="Your name"
                  isRounded
                  value={formData.name}
                  name="name"
                  onChange={onChange}
                  disabled={isValid === "valid" && formData.name}
                />
              </>
            ) : (
              <>
                <input
                  width="100%"
                  placeholder="Your Phone Number (Without Country Code)"
                  value={formData.phone}
                  name="phone"
                  onChange={onChange}
                  disabled={isValid !== "undefined"}
                  pattern="[0-9]*"
                  inputmode="numeric"
                  style={{
                    padding: "1rem",
                    borderRadius: "0.5rem",
                    border: "none",
                  }}
                />
              </>
            )}
            {isValid === "undefined" ? (
              <TryLuckButton onClick={onVerify}>Verify</TryLuckButton>
            ) : (
              <TryLuckButton onClick={onTryLuck}>Try your Luck</TryLuckButton>
            )}
          </OTPForm>
          <TermsButton onClick={onTCClick}>Terms & conditions</TermsButton>
        </div>
      </FormContainer>
    </MainFormContainer>
  );
};

const InfoText = styled.div`
  color: white;
  text-align: left;
  width: 100%;
  padding-left: 1rem;
  box-sizing: border-box;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  position: relative;
  > img {
    width: 1rem;
  }
  > div {
    color: white;
    position: absolute;
    width: 80%;
    background: #55038d88;
    padding: 0.5rem;
    bottom: 1.5rem;
    border-radius: 0.25rem;
    z-index: 9;
  }
`;
const OTPForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: 100%;
  box-sizing: border-box;
  gap: 1rem;
`;
const TryLuckButton = styled.button`
  padding: 1rem;
  background: #55038d;
  border: none;
  color: white;
  border-radius: 0.5rem;
  font-size: 1rem;
`;
const TermsButton = styled.button`
  padding: 0.5rem;
  background: transparent;
  border: none;
  color: aqua;
  font-size: 0.9rem;
  text-decoration: underline;
`;
const MainFormContainer = styled.div`
  min-height: 100vh;
  background-size: cover;
  background-image: url(${Scan1});
  background-position: center;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  height: 100vh;
`;

const BannerImage = styled.img`
  width: 65%;
  margin-top: 4rem;
  z-index: 2;
`;
const CrackerImages = styled.img`
  width: 100%;
  height: max-content;
  position: absolute;
  opacity: 0.5;
  z-index: 1;
`;

const PhoneInputWrapper = styled.div`
  background: white;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 0.25rem;
  display: flex;
`;

const StyledPhoneInput = styled(PhoneInput)`
  div > input {
    border: none;
    padding: 0.4rem;
    border-radius: 0.25rem;
    font-family: "Poppins";
    font-size: 1rem;
    line-height: 0.75rem;
    color: ${Colors.secondaryBlack};
    border: none;
    width: 1rem;
    &:focus {
      outline: none;
    }
  }
`;

export default ScanSignUpForm;
